import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import * as rrd from 'react-router-dom';

import {
  Home,
  Retry,
  Footer,
  Support,
  Convert,
  History,
  NotFound,
  Navigation,
  CookiePolicy,
  OAuthCallback,
  PrivacyPolicy,
  TermsOfService,
} from '@/pages';
import '@/App.css';
import { AuthProvider, OAuthProvider } from '@/providers';

const { Routes, Route } = rrd.default ?? rrd;

function App() {
  return (
    <>
      <Navigation />
      <Routes>
        <Route
          element={
            <AuthProvider>
              <OAuthProvider>
                <History />
              </OAuthProvider>
            </AuthProvider>
          }
          path="/history"
        />
        <Route
          element={
            <AuthProvider>
              <OAuthProvider>
                <Retry />
              </OAuthProvider>
            </AuthProvider>
          }
          path="/retry/:conversionId"
        />
        <Route
          element={
            <AuthProvider>
              <OAuthProvider>
                <Convert />
              </OAuthProvider>
            </AuthProvider>
          }
          path="/convert/:conversion?/:tab?"
        />
        <Route path="/" element={<Home />} />
        <Route path="/support" element={<Support />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route element={<OAuthCallback />} path="/oauth/callback/:platform" />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
